import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getV3GameProfile, patchV3GameProfile, postV3GameProfile } from "./thunks";
import { InterfaceProfile } from "../../entities/global";

interface V3GameProfileState {
  loading: boolean,
  saveLoading: boolean,
  profile?: InterfaceProfile,
}

const initialState: V3GameProfileState = {
  loading: false,
  saveLoading: false,
}

const saveCases = (
  builder: ActionReducerMapBuilder<V3GameProfileState>,
  action: any
) => {
  builder.addCase(action.pending, (state: V3GameProfileState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: V3GameProfileState, action: PayloadAction<InterfaceProfile>) => {
    state.saveLoading = false;
    state.profile = action.payload;
  });
  builder.addCase(action.rejected, (state: V3GameProfileState) => {
    state.saveLoading = false;
  });
};

export const v3GameProfileSlice = createSlice({
  name: "v3GameProfile",
  initialState: initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = undefined;
    }
  },
  extraReducers: (builder) => {
    // getV3GameProfile
    builder.addCase(getV3GameProfile.pending, state => {
      state.loading = true;
    })
    builder.addCase(getV3GameProfile.fulfilled, (state, action) => {
      state.profile = action.payload;

      state.loading = false;
    })
    const saveActions = [postV3GameProfile,
      patchV3GameProfile];

    saveActions.forEach((action) => { saveCases(builder, action) })
  },
})

export const { clearProfile } = v3GameProfileSlice.actions

export default v3GameProfileSlice.reducer;